import React, { CSSProperties, memo } from "react"; // Import CSSProperties for typing

export const contentStyle = {
  contentHeader: {
    padding: "8px 32px",
    flexGrow: 1,
    color: "#fff",
    backgroundColor: "#025A63",
    display: 'flex',
    alignItems: 'center', // Center content vertically
    
    justifyContent: 'space-between', // Push content to the sides
   
  } as CSSProperties,
  subcontentHeader: {
    padding: "8px 32px",
    flexGrow: 1,
    color: "#fff",
    backgroundColor: "#05777F",
    display: 'flex',
    alignItems: 'center', // Center content vertically
    justifyContent: 'space-between', // Push content to the sides
   
  } as CSSProperties,
  io: {
    position: "relative",
    padding: "8px 16px",
    flexGrow: 1
  }as CSSProperties,
  left: { left: "-8px" } as CSSProperties,
  textLeft: { textAlign: "left" } as CSSProperties,
  right: { right: "-8px" },
  textRight: { textAlign: "right" } as CSSProperties,
  handle: {
    widht: "10px", // Does not work
    height: "10px",
    margin: "auto",
    background: "#ddd",
    borderRadius: "15px",
    border: "2px solid #ddd",
    boxShadow:
      "rgba(0, 0, 0, 0.2) 0px 1px 3px 0px, rgba(0, 0, 0, 0.14) 0px 1px 1px 0px, rgba(0, 0, 0, 0.12) 0px 2px 1px -1px"
  } as CSSProperties,
  flexRow: {
    display: 'flex',
    alignItems: 'center',
  } as CSSProperties,
  inputContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '8px', // Add space between input rows
  } as CSSProperties,
  inputName: {
    fontWeight: 'bold',
    flexGrow: 1,
  } as CSSProperties,
  unitcard: {
    width: '40px', // Fixed width for consistency
    height: '30px', // Adjust the height as necessary
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    margin: '0 4px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.2)',
    fontSize: '0.8em',
  } as CSSProperties,
  amountcard: {
    width: '80px', // Fixed width for consistency
    height: '30px', // Adjust the height as necessary
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    margin: '0 4px',
    backgroundColor: '#f0f0f0',
    borderRadius: '4px',
    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.2)',
    fontSize: '0.8em',
  } as CSSProperties,
  inputamountcard: {
    width: '80px', // Fixed width for consistency
    height: '30px', // Adjust the height as necessary
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    margin: '0 4px',
    backgroundColor: '#FFF',
    borderRadius: '4px',
    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.2)',
    fontSize: '0.8em',
  } as CSSProperties,
  subtotalamountcard: {
    width: '80px', // Fixed width for consistency
    height: '30px', // Adjust the height as necessary
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    margin: '0 4px',
    backgroundColor: '#B7C1C4',
    borderRadius: '4px',
    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.2)',
    fontSize: '0.8em',
  } as CSSProperties,
  totalamountcard: {
    width: '80px', // Fixed width for consistency
    height: '30px', // Adjust the height as necessary
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    margin: '0 4px',
    backgroundColor: '#566E75',
    borderRadius: '4px',
    boxShadow: 'inset 0 0 5px rgba(0,0,0,0.2)',
    fontSize: '0.8em',
    color: "#fff",
  } as CSSProperties,
};

const style = {
  body: {
    display: "flex",
    flexDirection: "column",
    backgroundColor: "#fff",
    transition: "all 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
    boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
    border: "0px solid #bbb",
    borderRadius: "10px", // Add this line
    fontSize: "10pt"
  } as CSSProperties,
  selected: {
    boxShadow: "0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22)"
  } as CSSProperties,
  title: {
    position: "relative",
    padding: "8px 32px",
    flexGrow: 1,
    color: "#fff",
    backgroundColor: "#eee"
      } as CSSProperties,
  contentWrapper: {
    padding: "8px 0px"
  } as CSSProperties
};

interface NodeProps {
  label: string;
  selected: boolean;
  color?: string;
  content: React.ReactNode;
}
const Node: React.FC<NodeProps> = ({
  label,
  selected,
  color,
  content
}: NodeProps) => {
  let customTitleStyle: CSSProperties = { ...style.title, backgroundColor: color ?? "#0E303A" };

  return (
    <div style={{ ...style.body, ...(selected && style.selected) }}>
      <div style={customTitleStyle}>{label}</div>
      <div style={style.contentWrapper}>{content}</div>
    </div>
  );
};

export default memo(Node);